import {Slot, Text} from '@logistics-frontend/blocks'
import React from 'react'

import {renderWidget} from '..'
import {SlotWidgetConfig, WidgetType} from '../types'
import * as classes from './Slot.classes'

const SlotComponent = ({slot}: SlotWidgetConfig): React.ReactElement => {
  const {
    body1: {title},
    trail1,
  } = slot

  return (
    <Slot alignItems="center">
      <Text className={classes.text}>{title.items.map(renderWidget)}</Text>
      {trail1 && renderWidget(trail1)}
    </Slot>
  )
}

export const SlotWidget = (props: SlotWidgetConfig): React.ReactElement => {
  if (props.slot.trail1?.type === WidgetType.RADIO) {
    return (
      <label>
        <SlotComponent {...props} />
      </label>
    )
  }

  return <SlotComponent {...props} />
}
